/**
 * The Light Edit — article image carousel (.le-carousel)
 * Matches Jul 2026 review-site slider: arrows, dots, swipe.
 */
(function () {
  function initCarousel(root) {
    var track = root.querySelector('.le-track');
    var slides = root.querySelectorAll('.le-slide');
    var dots = root.querySelectorAll('.le-dot');
    var prev = root.querySelector('.le-prev');
    var next = root.querySelector('.le-next');
    if (!track || slides.length < 2) return;

    var index = 0;
    var n = slides.length;
    var startX = null;

    function go(k) {
      index = ((k % n) + n) % n;
      track.style.transform = 'translateX(-' + index * 100 + '%)';
      dots.forEach(function (dot, j) {
        if (j === index) {
          dot.classList.add('is-active');
        } else {
          dot.classList.remove('is-active');
        }
      });
    }

    if (prev) prev.addEventListener('click', function () { go(index - 1); });
    if (next) next.addEventListener('click', function () { go(index + 1); });
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        go(parseInt(dot.getAttribute('data-i'), 10) || 0);
      });
    });

    root.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX;
    }, { passive: true });

    root.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) go(index + (dx < 0 ? 1 : -1));
      startX = null;
    }, { passive: true });

    go(0);
  }

  function boot() {
    document.querySelectorAll('[data-le-carousel]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
